<template>
  <el-main>
    <div class="control-bar">
      <span class="title">管理日志</span>
    </div>

    <el-table :data="lists" border header-cell-class-name="table-header">
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="80">
      </el-table-column>
      <el-table-column label="操作人员" prop="scene_id">
        <template slot-scope="scope">{{ adminCates[scope.row.scene_id] ? adminCates[scope.row.scene_id].realname :
          scope.row.scene_id }}</template>
      </el-table-column>
      <el-table-column label="操作场景" prop="scene">
        <template slot-scope="scope">{{ $config.logScenes[scope.row.scene] ? $config.logScenes[scope.row.scene] :
          scope.row.scene }}</template>
      </el-table-column>
      <el-table-column label="操作方法" prop="method">
        <template slot-scope="scope">{{ $config.logMethods[scope.row.method] ? $config.logMethods[scope.row.method] :
          scope.row.method }}</template>
      </el-table-column>
      <el-table-column label="操作地址" prop="addr">
      </el-table-column>
      <el-table-column label="操作时间" prop="dateline" align="center" width="160">
        <template slot-scope="scope">{{ scope.row.dateline | timeTodate("Y-m-d H:i:s") }}</template>
      </el-table-column>
    </el-table>

    <el-pagination background layout="sizes, prev, pager, next, total" @size-change="handleSizeChange"
      :page-sizes="[10, 15, 20, 50, 100]" @current-change="getLists" :current-page="page" :page-size="$store.state.offset"
      :total="totals">
    </el-pagination>

    <!-- 添加信息 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">

    </el-dialog>
  </el-main>
</template>
<script>
import {
  httpRequest,
  getCookie,
  passwordCheck
} from '@/utils/app'
export default {
  data () {
    return {
      admin: {},
      adminCates: {},
      totals: 0,
      page: 1,
      lists: [],
      detail: {},
      dialogTitle: '',
      dialogVisible: false

    }
  },

  mounted () {
    httpRequest({
      action: 'admin_cates'
    }).then(response => {
      if (response.error === false) {
        this.adminCates = response.data
      }
    })

    this.getLists(1)
  },
  methods: {
    getLists (page) {
      let params = {
        action: 'log_lists',
        page: page,
        offset: this.$store.state.offset
      }

      httpRequest(params)
        .then(response => {
          if (response.error) {
            this.$message({
              type: 'error',
              message: response.msg
            })
            return
          }

          this.page = page
          this.lists = response.data
          this.totals = response.totals
        })
    },
    handleSizeChange: function (e) {
      this.$store.commit('setOffset', e)
      this.getLists(1);
    },
    indexMethod (index) {
      return index + (this.page - 1) * this.$store.state.offset + 1
    }
  }
}
</script>